/*
 * $.browser shim for the legacy jquery.fancybox 1.3.x bundled with this theme.
 *
 * jQuery 1.9 removed $.browser. fancybox reads $.browser.msie / $.browser.version at load time and
 * throws "Cannot read properties of undefined (reading 'msie')" under any modern jQuery.
 *
 * This file is loaded (deferred) IMMEDIATELY BEFORE jquery.fancybox.js, so window.jQuery here is
 * the exact instance fancybox is about to use — we shim $.browser on it so fancybox initializes
 * instead of crashing. (Deferred scripts run in document order, before DOMContentLoaded.)
 */
(function () {
  var jq = window.jQuery;
  if (jq && !jq.browser) {
    jq.browser = { msie: false, version: '0', webkit: false, mozilla: false, opera: false, safari: false };
  }
})();
